export const styles = {
  cardActionStyleSmall: {
    zIndex: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  },
  containerSmall: {
    padding: "3em 1em 6em 1em"
  },
  containerMedium: {
    padding: "0em 1em 1em 1em"
  },
  selectOptions: { width: "120px" },
  rowOptions: { width: "120px", paddingLeft: 0, paddingRight: 0 },
  rowFooter: { textAlign: "right", width: 30, padding: 0 },
  removeButton: { minWidth: 30 },
  containerToggle: { marginBottom: 16 },
  containerSmallFields: { width: 50 },
  containerActive: { width: 80 },
  headerTable: { color: "#FFFFFF" }
};



// WEBPACK FOOTER //
// ./src/sim/styles.js